import CheckoutMap from './checkout-map';

'use strict';

class ChooseYourUnit {
  constructor(elem) {
    this.target = elem;
    this.stepWrapper = this.target.closest('[data-step-toggle-active]');
    this.stepsWrapper = this.target.closest('[data-accommodation-active-step]');
    this.buttonOpen = this.stepWrapper.querySelector('[data-open-unit]');
    this.buttonClose = this.stepWrapper.querySelector('[data-close-unit]');
    this.contentAccommodation = this.stepWrapper.querySelector('[data-content-accommodation]');
    this.cyuFilter = this.target.querySelector('form#choose-your-unit-filters-form input[type="checkbox"]');
    this.events();
  }

  open() {
    this.target.classList.add('active');
    this.contentAccommodation.classList.remove('active');

    const checkoutMap = this.target.querySelector('.js-checkout-map');
    if (checkoutMap && !checkoutMap.checkoutUnitsMap) {
      checkoutMap.checkoutUnitsMap = new CheckoutMap(checkoutMap);
    }
  }

  close() {
    this.target.classList.remove('active');
    this.contentAccommodation.classList.add('active');
  }

  events() {
    if (this.buttonOpen) {
      this.buttonOpen.addEventListener('click', (e) => {
        this.open();
      });

      if (this.stepsWrapper.dataset.accommodationDefaultStep === 'cyu') {
        this.buttonOpen.click();
      }
    }

    if (this.buttonClose) {
      this.buttonClose.addEventListener('click', (e) => {
        this.close();
      });
    }

    if (this.cyuFilters) {
      this.cyuFilters.addEventListener('change', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const cyuFiltersModal = document.querySelector('[data-modal="modal-unit-filters"]:not(.modal-hidden)');
        
        if(cyuFiltersModal && cyuFiltersModal.modal) {
          cyuFiltersModal.modal.closeModal();
        }
      });
    }
  }
}

/* INIT ONLY WHEN CYU BLOCK WAS ADDED TO THE DOM */
document.addEventListener('init-chooseyourunit', (e) => {
  e.detail.element.cyu = new ChooseYourUnit(e.detail.element);
}, false);

/* const chooseYourUnit = document.querySelector('[data-target-unit]');
if (chooseYourUnit) {
  chooseYourUnit.cyu = new ChooseYourUnit(chooseYourUnit);
} */